
import { FastSimulation__FastComponentOf_6546966D, Driver, GatherData, GatherData__getFullSimName_6546966D, FastComponent, extractLabel, SimulationBudget_formatBytes, SimulationBudget_runtimeHeadroom, SimulationBudget_maxHeapBytes, SimulationBudget_maxTypedArrayBytes, IOArray, FData, StepArray$1, BigIntState as BigIntState_1, FastSimulation, SimulatedDesign, emptySimulatedDesign, StepCost as StepCost_1 } from "../SimTypes.js";
import { containsKey, add, FSharpMap__get_Item, empty } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { equalArrays, equals, createAtom, Exception, compareArrays } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { indexed, cons, iterateIndexed, filter, find, iterate, isEmpty, sumBy, map, toArray, exists, length, empty as empty_1 } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { printf, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { Record, toString } from "../../fable_modules/fable-library-js.5.13.0/Types.js";
import { iterateIndexed as iterateIndexed_1, append, concat, collect, mapIndexed, copyTo, setItem, map as map_1, fold, fill, initialize, item } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { toArray as toArray_1, toList } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.13.0/Range.js";
import { emptyFastData } from "../NumberHelpers.js";
import { SimGraph_iter, SimGraph_toList, SimulationComponentState, FastData, FastBits, SimulationError, SimulationErrorType, SimGraph_foldValues } from "../SimGraphTypes.js";
import { getHybridComponentAsyncOuts, isHybridComponent, couldBeSynchronousComponent } from "../SynchronousUtils.js";
import { max, min } from "../../fable_modules/fable-library-js.5.13.0/Double.js";
import { WaveIndexT, PortType, waveSimMaxArrayMargin } from "../../Common/CommonTypes.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { record_type, bigint_type, int32_type, array_type, uint32_type } from "../../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { fromZero } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { iteri, toArray as toArray_2, create, addItem } from "../../Common/LookupArray.js";
import { fcToInt } from "../../Common/Ids.js";
import { isIOLabel, isCustom, isInput, isOutput } from "../../Common/Helpers.js";
import { instrumentTime, instrumentInterval, getTimeMs } from "../../Common/TimeHelpers.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";

export function emptyFastSimulation(diagramName) {
    const StepCost = new StepCost_1(0, 0);
    return new FastSimulation(0, 0, new Array(0), new Array(0), new Array(0), new Array(0), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), empty_1(), new Array(0), empty({
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }), empty({
        Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
    }), 0, new Array(0), new Array(0), new SimulatedDesign(emptySimulatedDesign.DesignSheets, emptySimulatedDesign.DesignAsDrawn, diagramName, emptySimulatedDesign.DesignComponentsById, emptySimulatedDesign.DesignConnectionsByPort), StepCost);
}

export const simulationPlaceholder = emptyFastSimulation("");

export function getFid(cid, ap) {
    return [cid, ap];
}

export function getPortNumbers(sc) {
    let patternInput;
    const matchValue = sc.Type;
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 2:
        case 6:
        case 47:
        case 5:
        case 8:
        case 31:
        case 33:
        case 3:
        case 40:
        case 39:
        case 23:
        case 25:
        case 36: {
            patternInput = [1, 1];
            break;
        }
        case 4: {
            patternInput = [1, 0];
            break;
        }
        case 27:
        case 21:
        case 24:
        case 22:
        case 34:
        case 32:
        case 37: {
            patternInput = [2, 1];
            break;
        }
        case 28: {
            patternInput = [1, 2];
            break;
        }
        case 11:
        case 19:
        case 35: {
            patternInput = [3, 1];
            break;
        }
        case 12: {
            patternInput = [5, 1];
            break;
        }
        case 13: {
            patternInput = [9, 1];
            break;
        }
        case 17: {
            patternInput = [3, 2];
            break;
        }
        case 18: {
            patternInput = [2, 2];
            break;
        }
        case 20:
        case 46: {
            patternInput = [2, 1];
            break;
        }
        case 42:
        case 41: {
            patternInput = [3, 1];
            break;
        }
        case 9: {
            patternInput = [2, 4];
            break;
        }
        case 14: {
            patternInput = [2, 2];
            break;
        }
        case 15: {
            patternInput = [2, 4];
            break;
        }
        case 16: {
            patternInput = [2, 8];
            break;
        }
        case 10: {
            patternInput = [matchValue.fields[1], 1];
            break;
        }
        case 29: {
            patternInput = [matchValue.fields[0], 1];
            break;
        }
        case 30: {
            patternInput = [1, matchValue.fields[0]];
            break;
        }
        case 26: {
            const ct = matchValue.fields[0];
            patternInput = [length(ct.InputLabels), length(ct.OutputLabels)];
            break;
        }
        case 43:
        case 45:
        case 44: {
            patternInput = toFail(printf("legacy component type is not supported"));
            break;
        }
        case 48: {
            patternInput = toFail(printf("Legacy Input component types should never occur"));
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            patternInput = toFail(printf("Array sheet IO is removed by expansion and should never reach the simulator"));
            break;
        }
        case 54: {
            patternInput = [matchValue.fields[0], 1];
            break;
        }
        case 55: {
            patternInput = [matchValue.fields[0] + 1, 1];
            break;
        }
        default:
            patternInput = [0, 1];
    }
    return [patternInput[0], patternInput[1]];
}

export function compType(t) {
    if (t.tag === 26) {
        return t.fields[0].Name;
    }
    else {
        return toString(t);
    }
}

export function findBigIntState(fc) {
    const matchValue = fc.FType;
    let matchResult, w, m;
    switch (matchValue.tag) {
        case 3:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16: {
            matchResult = 2;
            break;
        }
        case 4: {
            matchResult = 3;
            break;
        }
        case 27: {
            matchResult = 4;
            break;
        }
        case 29: {
            matchResult = 5;
            break;
        }
        case 30: {
            matchResult = 6;
            break;
        }
        case 28: {
            matchResult = 7;
            break;
        }
        case 6: {
            matchResult = 8;
            break;
        }
        case 26: {
            matchResult = 10;
            break;
        }
        case 46: {
            matchResult = 11;
            break;
        }
        case 9:
        case 43:
        case 44:
        case 45: {
            matchResult = 12;
            break;
        }
        case 54: {
            matchResult = 13;
            break;
        }
        case 55: {
            matchResult = 14;
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            matchResult = 15;
            break;
        }
        case 49: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 7: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 48: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 0: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 1: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 2: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 22: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 24: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 23: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 17: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 18: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 19: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 20: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 25: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 21: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 33: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 34: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 35: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 36: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 37: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 38: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 47: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 5: {
            matchResult = 1;
            w = matchValue.fields[0];
            break;
        }
        case 39: {
            matchResult = 9;
            m = matchValue.fields[0];
            break;
        }
        case 40: {
            matchResult = 9;
            m = matchValue.fields[0];
            break;
        }
        case 41: {
            matchResult = 9;
            m = matchValue.fields[0];
            break;
        }
        case 42: {
            matchResult = 9;
            m = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [false, undefined];
        case 1:
            return [w > 32, undefined];
        case 2:
            return [item(0, fc.Outputs).Width > 32, undefined];
        case 3:
            return [false, undefined];
        case 4:
            return [((item(0, fc.InputLinks).Width > 32) ? true : (item(1, fc.InputLinks).Width > 32)) ? true : (item(0, fc.Outputs).Width > 32), new BigIntState_1([item(0, fc.InputLinks).Width > 32, item(1, fc.InputLinks).Width > 32], [item(0, fc.Outputs).Width > 32])];
        case 5: {
            const n_7 = matchValue.fields[0] | 0;
            return [(item(0, fc.Outputs).Width > 32) ? true : exists((n_9) => (item(n_9, fc.InputLinks).Width > 32), toList(rangeDouble(0, 1, n_7 - 1))), new BigIntState_1(toArray(map((n_11) => (item(n_11, fc.InputLinks).Width > 32), toList(rangeDouble(0, 1, n_7 - 1)))), [item(0, fc.Outputs).Width > 32])];
        }
        case 6: {
            const n_14 = matchValue.fields[0] | 0;
            return [(item(0, fc.InputLinks).Width > 32) ? true : exists((n_16) => (item(n_16, fc.Outputs).Width > 32), toList(rangeDouble(0, 1, n_14 - 1))), new BigIntState_1([item(0, fc.InputLinks).Width > 32], toArray(map((n_19) => (item(n_19, fc.Outputs).Width > 32), toList(rangeDouble(0, 1, n_14 - 1)))))];
        }
        case 7:
            return [item(0, fc.InputLinks).Width > 32, new BigIntState_1([item(0, fc.InputLinks).Width > 32], [item(0, fc.Outputs).Width > 32, item(1, fc.Outputs).Width > 32])];
        case 8:
            return [item(0, fc.InputLinks).Width > 32, new BigIntState_1([item(0, fc.InputLinks).Width > 32], [item(0, fc.Outputs).Width > 32])];
        case 9: {
            const matchValue_1 = m.WordWidth > 32;
            const matchValue_2 = m.AddressWidth > 32;
            if (matchValue_1) {
                if (matchValue_2) {
                    return [true, new BigIntState_1([true], [true])];
                }
                else {
                    return [true, new BigIntState_1([false], [true])];
                }
            }
            else if (matchValue_2) {
                return [true, new BigIntState_1([true], [false])];
            }
            else {
                return [false, undefined];
            }
        }
        case 10:
            return [false, undefined];
        case 11: {
            const matchValue_4 = matchValue.fields[0] > 32;
            if (matchValue_4) {
                return [true, new BigIntState_1([true, matchValue.fields[1] > 32], [true])];
            }
            else {
                return [false, undefined];
            }
        }
        case 12:
            throw new Exception("Legacy components, not Implemented");
        case 13:
            return [(item(0, fc.Outputs).Width > 32) ? true : (item(0, fc.InputLinks).Width > 32), new BigIntState_1(initialize(matchValue.fields[0], (i) => (item(i, fc.InputLinks).Width > 32)), [item(0, fc.Outputs).Width > 32])];
        case 14:
            return [item(0, fc.Outputs).Width > 32, new BigIntState_1(initialize(matchValue.fields[0] + 1, (i_1) => (item(i_1, fc.InputLinks).Width > 32)), [item(0, fc.Outputs).Width > 32])];
        default:
            throw new Exception("Array sheet IO is removed by expansion and should never reach the simulator");
    }
}

export let stepArrayIndex = createAtom(-1);

export function makeStepArray(arr) {
    stepArrayIndex(stepArrayIndex() + 1);
    return new StepArray$1(arr, stepArrayIndex());
}

export function makeIOArray(size) {
    stepArrayIndex(stepArrayIndex() + 1);
    return new IOArray(fill(new Array(2), 0, 2, new FData(/* Data */ 0, [emptyFastData])), new Uint32Array(0), new Array(0), 0, 0, 0, stepArrayIndex());
}

/**
 * One clock cycle of a bus of this width, in bytes of the memory it is stored in. See above, and
 * keep in step with makeIOArrayW immediately below: they describe the same allocation.
 */
export function stepBytesForWidth(w) {
    if (w <= 32) {
        return 4;
    }
    else {
        return (12 + (8 * ~~((w + 63) / 64))) | 0;
    }
}

/**
 * What one clock cycle of this design will cost, read straight off the merged SimulationGraph -
 * before it is flattened, before a FastComponent exists, and allocating nothing itself.
 * 
 * One step array is allocated per output port of every component of every INSTANCE, so that is
 * what is counted: the graph is walked the way the flatten walks it, descending into each custom
 * component's own graph, so a sheet used ten times is charged ten times.
 * 
 * It is deliberately taken from the graph and not from the flattened design. The flatten now
 * creates the step arrays as it goes, so a cost worked out from its output would be worked out
 * after the memory it is meant to refuse had been taken - see checkSimulationFits below, whose
 * whole point is to come first. Reading the graph keeps the check where it belongs and, as a
 * bonus, is what lets the waveform simulator's configuration dialog price a design
 * (ModelHelpers.waveSimStepCost) without building any of it.
 * 
 * Custom components are counted, not skipped: their output arrays are allocated and then
 * replaced by links to the arrays inside them (linkFastCustomComponentsToDriverArrays), and the
 * replaced ones stay in the step-array arena for the simulation's whole life. So this count is
 * exactly what a built simulation occupies, the replaced quarter included, not an estimate of it.
 * 
 * The per-step State array is counted too. Only RAMs ever write it, but createFastComponent
 * allocates one for every component that could be synchronous - customs included - so on a
 * register-heavy design it is real memory, and the estimate that omitted it said a design was
 * smaller than it is.
 * The count comes back alongside the cost because both are wanted at the same moment, by the
 * same caller, from the same walk: the build sizes its component store from the count so that
 * the store never has to grow, and refuses the design outright on the cost.
 */
export function costAndSizeOfGraph(graph) {
    const walk = (acc, graph_1) => SimGraph_foldValues((tupledArg, sComp) => {
        const count = tupledArg[2] | 0;
        const patternInput = fold((tupledArg_1, w) => {
            const typed_1 = tupledArg_1[0] | 0;
            const heap_1 = tupledArg_1[1] | 0;
            if (w <= 32) {
                return [typed_1 + stepBytesForWidth(w), heap_1];
            }
            else {
                return [typed_1, heap_1 + stepBytesForWidth(w)];
            }
        }, [tupledArg[0], tupledArg[1]], sComp.OutputWidths);
        const typed_2 = patternInput[0] | 0;
        const heap_2 = patternInput[1] | 0;
        const patternInput_1 = couldBeSynchronousComponent(sComp.Type) ? [typed_2, heap_2 + 4] : [typed_2, heap_2];
        const typed_3 = patternInput_1[0] | 0;
        const heap_3 = patternInput_1[1] | 0;
        const matchValue_1 = sComp.CustomSimulationGraph;
        let matchResult, csg;
        if (sComp.Type.tag === 26) {
            if (matchValue_1 != null) {
                matchResult = 0;
                csg = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return walk([typed_3, heap_3, count + 1], csg);
            default:
                return [typed_3, heap_3, count + 1];
        }
    }, acc, graph_1);
    const tupledArg_2 = walk([0, 0, 0], graph);
    return [new StepCost_1(tupledArg_2[0], tupledArg_2[1]), tupledArg_2[2]];
}

export function stepCostOfGraph(graph) {
    return costAndSizeOfGraph(graph)[0];
}

/**
 * The most clock cycles of a design costing this much that will be allowed, whichever of the two
 * budgets binds first. Used both to refuse a simulation and to say in the waveform simulator's
 * configuration what may be asked for, so that the two cannot disagree.
 */
export function maxCyclesFor(cost) {
    let value;
    const limit = (bytesPerStep, budget) => {
        if (bytesPerStep === 0) {
            return Number.POSITIVE_INFINITY;
        }
        else {
            return budget / bytesPerStep;
        }
    };
    return ~~((value = min(2147483647, min(limit(cost.TypedArrayBytes, SimulationBudget_maxTypedArrayBytes()), limit(cost.HeapBytes, SimulationBudget_maxHeapBytes()))), Math.floor(value))) | 0;
}

/**
 * The largest WSConfig.LastClock a design costing this much can be configured to. maxCyclesFor
 * bounds the step ARRAYS, and the arrays carry a zoom margin past the last clock - up to
 * CommonTypes.waveSimMaxArrayMargin - so the two numbers differ by exactly that margin. Every
 * message that tells the user what may be ASKED for must quote this one: quoting the array
 * bound as a configuration value told the user to set a number that was itself refused.
 */
export function maxLastClockFor(cost) {
    return max(0, maxCyclesFor(cost) - waveSimMaxArrayMargin) | 0;
}

/**
 * Refuse a simulation whose step arrays would not fit, before a byte of them is allocated.
 * 
 * Before rather than after, because the arrays ARE what exhausts memory: a check that had to build
 * them first would be the thing it is meant to prevent. Everything it needs is known by then - the
 * flattened design gives every width, and the caller has said how many cycles it wants - so the
 * answer is exact rather than a guess.
 * 
 * A Result and not an exception: this is a limit an ordinary user reaches by asking for a long
 * waveform simulation of a big design, so it travels the same path as any other simulation error
 * and is shown the same way, saying what would fit instead.
 * 
 * The line enforced here is the budget times SimulationBudget.runtimeHeadroom, not the budget:
 * this check is the crash guard of last resort, and the configuration dialog - which holds
 * users to the budgets exactly - is the advertised limit. The gap is for the simulation that
 * arrives without passing that dialog, a LastClock saved into a sheet on a larger machine above
 * all, which should run if it safely can rather than fail the moment Start is pressed. The
 * advice in the refusal still quotes the dialog's own bound, so following it always works.
 */
export function checkSimulationFits(arraySize, cost) {
    const check = (bytesPerStep, budget, ofWhat) => {
        const needed = bytesPerStep * arraySize;
        const enforced = budget * SimulationBudget_runtimeHeadroom;
        if ((bytesPerStep === 0) ? true : (needed <= enforced)) {
            return new FSharpResult$2(/* Ok */ 0, [undefined]);
        }
        else {
            return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [`This design needs ${SimulationBudget_formatBytes(bytesPerStep)} of ${ofWhat} for every clock cycle, so the ${arraySize} cycles of step storage this simulation asks for (its last clock cycle plus the zoom margin) would need ${SimulationBudget_formatBytes(needed)} - more than the ${SimulationBudget_formatBytes(enforced)} Issie will risk. Set the waveform simulator's last clock cycle, in its configuration, to at most ${maxLastClockFor(cost)}, or simulate one subsheet rather than the whole design.`]), undefined, empty_1(), empty_1())]);
        }
    };
    return Result_Bind(() => check(cost.HeapBytes, SimulationBudget_maxHeapBytes(), "heap memory, which buses wider than 32 bits need,"), check(cost.TypedArrayBytes, SimulationBudget_maxTypedArrayBytes(), "simulation memory"));
}

class StepArena extends Record {
    constructor(U32Slab, U32Next, U32Planned, BigSlab, BigNext, BigPlanned) {
        super();
        this.U32Slab = U32Slab;
        this.U32Next = (U32Next | 0);
        this.U32Planned = (U32Planned | 0);
        this.BigSlab = BigSlab;
        this.BigNext = (BigNext | 0);
        this.BigPlanned = (BigPlanned | 0);
    }
}

function StepArena_$reflection() {
    return record_type("FastCreate.StepArena", [], StepArena, () => [["U32Slab", array_type(uint32_type)], ["U32Next", int32_type], ["U32Planned", int32_type], ["BigSlab", array_type(bigint_type)], ["BigNext", int32_type], ["BigPlanned", int32_type]]);
}

const u32SlabSize = (64 * 1024) * 1024;

const bigSlabSize = (4 * 1024) * 1024;

function plannedElements(bytesPerStep, steps, elementBytes, limit) {
    return max(0, ~~min(limit, (bytesPerStep * steps) / elementBytes)) | 0;
}

let stepArena = undefined;

/**
 * Start drawing step regions from arena slabs, sized for what this build is about to need.
 * 
 * The size matters more than it looks. A slab used to be a fixed 256MB whatever was being built,
 * so EVERY simulation - a three-component test circuit as much as a CPU - allocated and zeroed
 * 256MB before it could hold its first cycle. Under .NET that is a large-object allocation per
 * build, and a test suite that builds a few thousand small simulations spent eight minutes of its
 * twelve doing nothing else. The cost of a build is now the cost of what it holds.
 * 
 * The numbers come from `stepCostOfGraph`, which is computed for the memory budget before the
 * arrays are allocated and charges for exactly what the arena keeps - so the first slab is the
 * whole of an ordinary build. A build that needs more than a slab, or more than was planned for,
 * simply takes another; nothing depends on the estimate being right.
 * 
 * Callers must pair this with finishStepArena however the build ends, or the next truth-table
 * build would draw from a slab nobody meant it to share.
 */
export function startStepArena(cost, steps) {
    stepArena = (new StepArena(new Uint32Array(0), 0, plannedElements(cost.TypedArrayBytes, steps, 4, u32SlabSize), new Array(0), 0, plannedElements(cost.HeapBytes, steps, 4, bigSlabSize)));
}

export function finishStepArena() {
    stepArena = undefined;
}

function makeU32Region(size) {
    let matchResult, arena_1;
    if (stepArena != null) {
        if (size <= u32SlabSize) {
            matchResult = 0;
            arena_1 = stepArena;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            if ((arena_1.U32Slab.length - arena_1.U32Next) < size) {
                const slab = max(size, min(u32SlabSize, arena_1.U32Planned)) | 0;
                arena_1.U32Slab = (new Uint32Array(slab));
                arena_1.U32Planned = (min(u32SlabSize, slab * 2) | 0);
                arena_1.U32Next = 0;
            }
            const regionBase = arena_1.U32Next | 0;
            arena_1.U32Next = ((regionBase + size) | 0);
            return [arena_1.U32Slab, regionBase];
        }
        default:
            return [new Uint32Array(size), 0];
    }
}

function makeBigRegion(size) {
    let matchResult, arena_1;
    if (stepArena != null) {
        if (size <= bigSlabSize) {
            matchResult = 0;
            arena_1 = stepArena;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            if ((arena_1.BigSlab.length - arena_1.BigNext) < size) {
                const slab = max(size, min(bigSlabSize, arena_1.BigPlanned)) | 0;
                arena_1.BigSlab = fill(new Array(slab), 0, slab, fromZero());
                arena_1.BigPlanned = (min(bigSlabSize, slab * 2) | 0);
                arena_1.BigNext = 0;
            }
            const regionBase = arena_1.BigNext | 0;
            arena_1.BigNext = ((regionBase + size) | 0);
            return [arena_1.BigSlab, regionBase];
        }
        default:
            return [fill(new Array(size), 0, size, fromZero()), 0];
    }
}

export function makeIOArrayW(w, size) {
    stepArrayIndex(stepArrayIndex() + 1);
    if (w <= 32) {
        const w_2 = w | 0;
        const patternInput = makeU32Region(size);
        return new IOArray(fill(new Array(2), 0, 2, new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), w_2)])), patternInput[0], new Array(0), patternInput[1], size, w_2, stepArrayIndex());
    }
    else {
        const patternInput_1 = makeBigRegion(size);
        return new IOArray(fill(new Array(2), 0, 2, new FData(/* Data */ 0, [new FastData(new FastBits(/* BigWord */ 1, [fromZero()]), w)])), new Uint32Array(0), patternInput_1[0], patternInput_1[1], size, w, stepArrayIndex());
    }
}

/**
 * create a FastComponent data structure with data arrays from a SimulationComponent.
 * numSteps is the number of past clocks data kept - arrays are managed as circular buffers.
 * 
 * fullName is given rather than filled in afterwards: the flatten stores this object in its
 * index space, and `{ fc with FullName = ... }` afterwards would put a DIFFERENT object there than
 * the one the caller kept - a copy of a 23-field record per component, and a reference-equal
 * identity broken, for a string that is known when it is made.
 */
export function createFastComponent(maxArraySize, sComp, accessPath, fullName) {
    let bind$0040;
    const patternInput = getPortNumbers(sComp);
    const outPortNum = patternInput[1] | 0;
    const inPortNum = patternInput[0] | 0;
    const ins = map_1((n) => {
        const matchValue = sComp.Type;
        if (matchValue.tag === 0) {
            return makeIOArrayW(matchValue.fields[0], maxArraySize);
        }
        else {
            return makeIOArray(maxArraySize);
        }
    }, toArray_1(rangeDouble(0, 1, inPortNum - 1)));
    let outs;
    const matchValue_2 = sComp.OutputWidths.length | 0;
    let matchResult;
    if (sComp.Type.tag === 3) {
        if (matchValue_2 === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            outs = [makeIOArray(maxArraySize)];
            break;
        }
        default:
            outs = map_1((w) => makeIOArrayW(w, maxArraySize), sComp.OutputWidths);
    }
    const state = couldBeSynchronousComponent(sComp.Type) ? fill(new Array(maxArraySize), 0, maxArraySize, SimulationComponentState.NoState) : undefined;
    const fId = getFid(sComp.Id, accessPath);
    const matchValue_4 = sComp.Type;
    if (matchValue_4.tag === 0) {
        setItem(ins, 0, (bind$0040 = item(0, ins), new IOArray(bind$0040.FDataStep, bind$0040.UInt32Slab, bind$0040.BigIntSlab, bind$0040.StepBase, bind$0040.StepLength, matchValue_4.fields[0], bind$0040.Index)));
    }
    let State;
    const option = state;
    State = ((option != null) ? makeStepArray(option) : undefined);
    const CustomInLinks = (sComp.Type.tag === 26) ? fill(new Array(inPortNum), 0, inPortNum, -1) : (new Array(0));
    let NumMissingInputValues;
    const sc = sComp;
    const ipn = inPortNum | 0;
    NumMissingInputValues = (isHybridComponent(sc.Type) ? sumBy((ipn_1) => {
        const _arg = getHybridComponentAsyncOuts(sc.Type, ipn_1);
        let matchResult_1;
        if (_arg != null) {
            if (isEmpty(_arg)) {
                matchResult_1 = 0;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 0;
        }
        switch (matchResult_1) {
            case 0:
                return 0;
            default:
                return 1;
        }
    }, toList(rangeDouble(0, 1, ipn)), {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) : ipn);
    const InputDrivers = fill(new Array(inPortNum), 0, inPortNum, undefined);
    const FLabel = extractLabel(sComp.Label);
    const VerilogOutputName = fill(new Array(outPortNum), 0, outPortNum, "");
    return new FastComponent(fId, sComp.Id, sComp.Type, State, !(sComp.Type.tag === 3), false, undefined, ins, InputDrivers, outs, sComp, accessPath, fullName, FLabel, (_arg_1) => {
        toFail(printf("Reducer for %A was never installed"))(sComp.Type);
    }, (_arg_2) => {
        toFail(printf("Reducer for %A was never installed"))(sComp.Type);
    }, -1, new Array(0), CustomInLinks, -1, 0, false, empty_1(), NumMissingInputValues, VerilogOutputName, "");
}

class SiblingIndex extends Record {
    constructor(Ix) {
        super();
        this.Ix = Ix;
    }
}

function SiblingIndex_$reflection() {
    return record_type("FastCreate.SiblingIndex", [], SiblingIndex, () => [["Ix", array_type(int32_type)]]);
}

const storeGrowthCap = 65536;

function ensureId(g, sib, i) {
    if (i >= g.Labels.length) {
        const bigger = fill(new Array(max(2 * g.Labels.length, i + 1)), 0, max(2 * g.Labels.length, i + 1), "*");
        copyTo(g.Labels, 0, bigger, 0, g.Labels.length);
        g.Labels = bigger;
    }
    if (i >= sib.Ix.length) {
        const bigger_1 = new Int32Array(max(2 * sib.Ix.length, i + 1));
        copyTo(sib.Ix, 0, bigger_1, 0, sib.Ix.length);
        sib.Ix = bigger_1;
    }
}

function flattenLevel(g, sib, maxArraySize, ap, graph, parent) {
    const graphL = SimGraph_toList(graph);
    iterate((tupledArg) => {
        const i = tupledArg[0];
        ensureId(g, sib, i);
        g.Labels[i] = extractLabel(tupledArg[1].Label);
    }, graphL);
    const created = map((tupledArg_1) => {
        const comp_1 = tupledArg_1[1];
        const cid_1 = tupledArg_1[0];
        const fc_1 = addItem(createFastComponent(maxArraySize, comp_1, ap, GatherData__getFullSimName_6546966D(g, getFid(cid_1, ap))), g.Comps);
        sib.Ix[cid_1] = (fcToInt(fc_1.Index) | 0);
        return [comp_1, fc_1];
    }, graphL);
    iterate((tupledArg_2) => {
        const comp_2 = tupledArg_2[0];
        const fc_2 = tupledArg_2[1];
        const outLinks = initialize(max(max(fc_2.Outputs.length, 1), comp_2.Outputs.length), (k) => ((k < comp_2.Outputs.length) ? map_1((tupledArg_3) => [item(tupledArg_3[0], sib.Ix), tupledArg_3[1]], toArray(item(k, comp_2.Outputs))) : []));
        fc_2.OutLinks = outLinks;
    }, created);
    if (parent != null) {
        const customIndex = parent[0] | 0;
        const ct = parent[1];
        const custom = item(customIndex, g.Comps.Items);
        const indexOf = (candidates, tupledArg_4) => {
            const fc_3 = find((tupledArg_5) => {
                let t;
                const comp_3 = tupledArg_5[0];
                if (equals(comp_3.Label, tupledArg_4[0])) {
                    return ((t = comp_3.Type, (t.tag === 0) ? t.fields[0] : ((t.tag === 1) ? t.fields[0] : -1))) === tupledArg_4[1];
                }
                else {
                    return false;
                }
            }, candidates)[1];
            return fc_3.Index;
        };
        const outputs = filter((tupledArg_6) => isOutput(tupledArg_6[0].Type), created);
        iterateIndexed((i_3, labelled) => {
            const inner = item(fcToInt(indexOf(outputs, labelled)), g.Comps.Items);
            inner.CustomOutIndex = customIndex;
            inner.CustomOutPort = (i_3 | 0);
        }, ct.OutputLabels);
        const inputs = filter((tupledArg_7) => isInput(tupledArg_7[0].Type), created);
        iterateIndexed((i_5, labelled_1) => {
            custom.CustomInLinks[i_5] = indexOf(inputs, labelled_1);
        }, ct.InputLabels);
    }
    iterate((tupledArg_8) => {
        const comp_6 = tupledArg_8[0];
        const matchValue = comp_6.Type;
        const matchValue_1 = comp_6.CustomSimulationGraph;
        let matchResult, csg, ct_1;
        if (matchValue.tag === 26) {
            if (matchValue_1 != null) {
                matchResult = 0;
                csg = matchValue_1;
                ct_1 = matchValue.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                flattenLevel(g, sib, maxArraySize, cons(comp_6.Id, ap), csg, [fcToInt(tupledArg_8[1].Index), ct_1]);
                break;
            }
            case 1: {
                break;
            }
        }
    }, created);
}

/**
 * Flatten the SimulationGraph into the one index space the rest of the build works in, creating
 * every FastComponent - and so every step array - as it goes.
 * 
 * size is how many components the expanded design has, from costAndSizeOfGraph, so the store is
 * made at exactly the right size and never grows. That same walk is what priced the design and
 * refused it if it would not fit, which is why this may allocate at all: by the time it runs the
 * budget has been checked and the step-array arena opened for what it said.
 */
export function gatherSimulation(maxArraySize, size, graph) {
    const startTime = getTimeMs();
    stepArrayIndex(-1);
    const g = new GatherData(create((fc) => (fcToInt(fc.Index) | 0), (fc_1, i) => {
        fc_1.Index = i;
        return fc_1;
    }, size, storeGrowthCap), fill(new Array(64), 0, 64, "*"));
    flattenLevel(g, new SiblingIndex(new Int32Array(64)), maxArraySize, empty_1(), graph, undefined);
    return instrumentInterval("gatherGraph", startTime, g);
}

/**
 * Add one driver changing the fs.Driver array reference.
 * Return a WaveIndex reference.
 * WaveIndex refrences are bound to specific component ports
 * and not unique per driver.
 * Whether a port of a component carries a waveform the user can watch.
 * 
 * The rules the wave index is built from, said once. They used to live only inside
 * addComponentWaveDrivers, which walks every port of every component of the whole expanded
 * simulation; anything wanting to know which ports one INSTANCE offers - without walking the
 * expansion to find out - has to decide it the same way, and two copies of a rule like this
 * drift. The builder below now asks this, so there is one answer.
 * 
 * What is excluded, and why each: the input side of components whose input is not a signal of
 * its own (an IOLabel, an Input1, a Viewer, a NotConnected, an Output); a Constant1, whose
 * output drives but is not worth watching; every IOLabel of a same-named group except the one
 * elected to drive it, since they are all one net; the wiring components, which carry no signal
 * distinct from what they are wired to; and the Input1 and Output components INSIDE a subsheet,
 * whose signal is the enclosing custom component's port and is offered there instead.
 */
export function portCarriesWave(f, fc, pType) {
    const matchValue = fc.FType;
    let matchResult;
    switch (matchValue.tag) {
        case 3: {
            if (pType.tag === 0) {
                matchResult = 0;
            }
            else if (!equalArrays(FSharpMap__get_Item(f.FIOActive, [fc.FLabel, fc.fId[1]]).fId, fc.fId)) {
                matchResult = 2;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 0: {
            if (pType.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 2: {
            if (pType.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 4: {
            if (pType.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 1: {
            if (pType.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 7: {
            matchResult = 1;
            break;
        }
        default:
            matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return false;
        case 1:
            return false;
        case 2:
            return false;
        default: {
            const matchValue_2 = fc.FType;
            let matchResult_1;
            switch (matchValue_2.tag) {
                case 28:
                case 6:
                case 27:
                case 29:
                case 30:
                case 54:
                case 7: {
                    matchResult_1 = 0;
                    break;
                }
                case 1: {
                    if (!equals(fc.AccessPath, empty_1())) {
                        matchResult_1 = 1;
                    }
                    else {
                        matchResult_1 = 3;
                    }
                    break;
                }
                case 0: {
                    if (!equals(fc.AccessPath, empty_1())) {
                        matchResult_1 = 2;
                    }
                    else {
                        matchResult_1 = 3;
                    }
                    break;
                }
                default:
                    matchResult_1 = 3;
            }
            switch (matchResult_1) {
                case 0:
                    return false;
                case 1:
                    return false;
                case 2:
                    return false;
                default:
                    return true;
            }
        }
    }
}

export function addComponentWaveDrivers(f, fc, pType) {
    return mapIndexed((pn_2, stepA_1) => {
        let fc_1, option, d;
        const driver = stepA_1.Index | 0;
        let addDriver;
        const matchValue = fc.FType;
        let matchResult;
        switch (matchValue.tag) {
            case 3: {
                if (pType.tag === 0) {
                    matchResult = 0;
                }
                else if ((fc_1 = fc, !equalArrays(FSharpMap__get_Item(f.FIOActive, [fc_1.FLabel, fc_1.fId[1]]).fId, fc_1.fId))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 0: {
                if (pType.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 2: {
                if (pType.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 4: {
                if (pType.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 1: {
                if (pType.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 7: {
                matchResult = 1;
                break;
            }
            default:
                matchResult = 3;
        }
        switch (matchResult) {
            case 0: {
                addDriver = false;
                break;
            }
            case 1: {
                addDriver = true;
                break;
            }
            case 2: {
                addDriver = false;
                break;
            }
            default:
                addDriver = true;
        }
        if (equals(pType, PortType.Output) && addDriver) {
            const index_1 = driver | 0;
            f.Drivers[index_1] = defaultArg(item(index_1, f.Drivers), new Driver(index_1, 0, stepA_1));
            const output = item(pn_2, fc.Outputs);
            f.Drivers[index_1] = ((option = item(index_1, f.Drivers), (option != null) ? ((d = option, new Driver(d.Index, output.Width, d.DriverData))) : undefined));
        }
        if (portCarriesWave(f, fc, pType)) {
            return [new WaveIndexT(driver, fc.fId, pType, pn_2)];
        }
        else {
            return [];
        }
    }, (pType.tag === 0) ? fc.InputLinks : fc.Outputs);
}

/**
 * Called after the fs.Drivers array is created.
 * waveComps must contain all components that can be viewed in the wave simulation.
 * This function mutates fs.Drivers adding the correct arrays where
 * these are used. In some cases an array may never be used and therefore is not added.
 * In parallel with this, the function returns an array of WaveIndexT records that
 * reference component ports which can be viewed in a wave simulation.
 * Every WaveIndex references an element of fs.Drivers from which the simulation data is found.
 */
export function addWaveIndexAndDrivers(comps, f) {
    const addDrivers = (pType, array) => collect((fc) => addComponentWaveDrivers(f, fc, pType), array);
    return concat(append(addDrivers(PortType.Output, comps), addDrivers(PortType.Input, comps)));
}

/**
 * Changes all the custom component in and out StepArray links so they point to the correct drivers.
 * (fid, fc) must be a custom component.
 * Called after the simulation has been fully constructed and linked.
 */
export function linkFastCustomComponentsToDriverArrays(fs, fid_, fid__1, fc) {
    let matchValue_1;
    const fid = [fid_, fid__1];
    const ap = cons(fid[0], fid[1]);
    let ct_1;
    const matchValue = fc.FType;
    ct_1 = ((matchValue.tag === 26) ? matchValue.fields[0] : toFail(printf("linkFastCustomComponent must be called with a custom component")));
    SimGraph_iter((cid_1, sc) => {
        const matchValue_2 = sc.Type;
        switch (matchValue_2.tag) {
            case 0: {
                const portNum = find((tupledArg) => (tupledArg[1][0] === sc.Label), indexed(ct_1.InputLabels))[0] | 0;
                fc.InputLinks[portNum] = item(0, FastSimulation__FastComponentOf_6546966D(fs, [cid_1, ap]).Outputs);
                break;
            }
            case 1: {
                const portNum_1 = find((tupledArg_1) => (tupledArg_1[1][0] === sc.Label), indexed(ct_1.OutputLabels))[0] | 0;
                fc.Outputs[portNum_1] = item(0, FastSimulation__FastComponentOf_6546966D(fs, [cid_1, ap]).InputLinks);
                break;
            }
            default:
                undefined;
        }
    }, (matchValue_1 = fc.SimComponent.CustomSimulationGraph, (matchValue_1 == null) ? toFail(printf("What? Can\'t find customSimulationGraph")) : matchValue_1));
}

/**
 * Point every custom component's ports at the arrays of the Input and Output components inside
 * it, so that reading a custom component's port reads the signal it actually carries.
 * 
 * Not optional, and not part of the wave tables below even though it used to be in the same
 * phase: a port that points at the dummy array it was created with reads as nothing. Cheap - one
 * re-pointing per port of each custom component, and there are far fewer of those than of
 * ordinary ones.
 * 
 * `comps` is every component of the build in creation order - the array the gather filled, not
 * the maps. See the note on createFastArrays: walking the maps here means walking the components
 * in a different order from the one they were allocated in, and on a design of any size that is
 * most of what this phase costs.
 */
export function linkCustomComponentPorts(comps, fs) {
    comps.forEach((fc) => {
        if (isCustom(fc.FType)) {
            const tupledArg = fc.fId;
            linkFastCustomComponentsToDriverArrays(fs, tupledArg[0], tupledArg[1], fc);
        }
    });
    return fs;
}

/**
 * Adds the Drivers and WaveIndex fields to a fast simulation.
 * For use by waveform Simulator.
 * Needs to be run after widths are calculated.
 * 
 * **What a simulation needs only in order to be DRAWN**, and all of it sized by the expansion:
 * a map of every component of every instance, an entry per step array, and an entry per
 * wave-carrying port. `WaveTables` is what decides whether a build pays for them; a simulator
 * that runs and answers reads by name does not.
 */
export function addWavesToFastSimulation(comps, fs) {
    let fs_1;
    const Drivers = fill(new Array(fs.NumStepArrays), 0, fs.NumStepArrays, undefined);
    fs_1 = (new FastSimulation(fs.ClockTick, fs.MaxArraySize, fs.FGlobalInputComps, fs.FConstantComps, fs.FClockedComps, fs.FOrderedComps, fs.FIOActive, fs.FIOLinks, fs.FCompsByIndex, fs.FIndexOf, fs.FCustomOutputCompLookup, fs.NumStepArrays, Drivers, fs.WaveIndex, fs.Design, fs.StepCost));
    const WaveIndex = addWaveIndexAndDrivers(comps, fs_1);
    return new FastSimulation(fs_1.ClockTick, fs_1.MaxArraySize, fs_1.FGlobalInputComps, fs_1.FConstantComps, fs_1.FClockedComps, fs_1.FOrderedComps, fs_1.FIOActive, fs_1.FIOLinks, fs_1.FCompsByIndex, fs_1.FIndexOf, fs_1.FCustomOutputCompLookup, fs_1.NumStepArrays, fs_1.Drivers, WaveIndex, fs_1.Design, fs_1.StepCost);
}

/**
 * The door between the build's index space and the rest of the program.
 * 
 * It used to create the FastComponents as well; the flatten does that now, so what is left of it
 * is the boundary. What a built simulation offers is the STORE - FCompsByIndex, in gather order -
 * and one map, FIndexOf, from the design-time name a caller arrives with to a place in it. The
 * name is what survives a rebuild and so what the renderer holds; the index is what everything
 * inside the simulation works in.
 * 
 * Custom against ordinary is decided here, by a predicate over the one store. It is not a second
 * index space and must not become one: the links the flatten resolved are positions in this
 * store, and splitting it would make the same integer mean two different things.
 */
export function createInitFastCompPhase(simulationArraySize, g, f) {
    const start = getTimeMs();
    const all = toArray_2(g.Comps);
    const indexOfName = fold((m, fc) => add(fc.fId, fc.Index, m), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), all);
    const customOutLookup = fold((m_1, fc_1) => {
        if (fcToInt(fc_1.CustomOutIndex) < 0) {
            return m_1;
        }
        else {
            return add([item(fcToInt(fc_1.CustomOutIndex), g.Comps.Items).fId, fc_1.CustomOutPort], fc_1.Index, m_1);
        }
    }, empty({
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }), all);
    instrumentTime("createInitFastCompPhase", start);
    const NumStepArrays = (stepArrayIndex() + 1) | 0;
    return new FastSimulation(f.ClockTick, simulationArraySize, f.FGlobalInputComps, f.FConstantComps, f.FClockedComps, f.FOrderedComps, f.FIOActive, f.FIOLinks, all, indexOfName, customOutLookup, NumStepArrays, new Array(0), f.WaveIndex, f.Design, f.StepCost);
}

function reLinkIOLabels(fs) {
    iterate((tupledArg) => {
        const _arg = tupledArg[0];
        const ioDriver = tupledArg[1];
        const ipn = _arg[1];
        const fcDriven = _arg[0];
        const fcActiveDriver = FSharpMap__get_Item(fs.FIOActive, [ioDriver.SimComponent.Label, ioDriver.AccessPath]);
        fcDriven.InputLinks[ipn] = item(0, fcActiveDriver.Outputs);
        fcDriven.InputDrivers[ipn] = [fcActiveDriver.Index, 0];
        const matchValue = getHybridComponentAsyncOuts(fcDriven.FType, ipn);
        let matchResult;
        if (matchValue != null) {
            if (!isEmpty(matchValue)) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0: {
                fcActiveDriver.DrivenComponents = cons(fcDriven, fcActiveDriver.DrivenComponents);
                break;
            }
        }
        ioDriver.Outputs[0] = item(0, fcActiveDriver.Outputs);
    }, fs.FIOLinks);
}

/**
 * Use the links the flatten resolved to tie the FastComponents' data arrays together.
 * InputLinks[i] is set equal to the driving Outputs array, so that input i reads the data
 * reduced by the correct output of the component that drives it.
 * The main work is dealing with custom components, which represent whole design sheets with
 * recursively defined component graphs. The custom component itself is not linked and does not
 * exist as a simulatable FastComponent - instead its graph's Input and Output components are
 * linked to whatever connects to the corresponding ports of the custom component.
 * Note: custom components are linked in later as unsimulatable placeholders, to let the wave
 * simulation reach their ports.
 * 
 * Everything here works in store indices. It used to work in (ComponentId, access path) pairs
 * against four maps, and that was the build's shape problem: a structural key costs a boxed
 * comparison of a GUID-like id and a list per tree level, and this function does one per link of
 * every component of the expanded design.
 */
export function linkFastComponents(g, f) {
    const start = getTimeMs();
    const store = g.Comps;
    const getLinks = (fci_mut, opn_mut, ipnOpt_mut) => {
        getLinks:
        while (true) {
            const fci = fci_mut, opn = opn_mut, ipnOpt = ipnOpt_mut;
            const fc = item(fcToInt(fci), store.Items);
            const matchValue = isOutput(fc.FType);
            const matchValue_1 = isCustom(fc.FType);
            let matchResult, ipn, ipn_1, x;
            if (matchValue) {
                if (ipnOpt != null) {
                    if (matchValue_1) {
                        matchResult = 5;
                        x = [matchValue, matchValue_1, ipnOpt];
                    }
                    else {
                        matchResult = 3;
                        ipn_1 = ipnOpt;
                    }
                }
                else if (equals(fc.AccessPath, empty_1())) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else if (matchValue_1) {
                if (ipnOpt == null) {
                    matchResult = 4;
                }
                else {
                    const copyOfStruct = ipnOpt;
                    matchResult = 2;
                    ipn = copyOfStruct;
                }
            }
            else if (ipnOpt == null) {
                matchResult = 4;
            }
            else {
                matchResult = 3;
                ipn_1 = ipnOpt;
            }
            switch (matchResult) {
                case 0:
                    return [];
                case 1: {
                    fci_mut = fc.CustomOutIndex;
                    opn_mut = fc.CustomOutPort;
                    ipnOpt_mut = undefined;
                    continue getLinks;
                }
                case 2:
                    return [[item(ipn, fc.CustomInLinks), 0]];
                case 3:
                    return [[fci, ipn_1]];
                case 4:
                    return collect((tupledArg) => getLinks(tupledArg[0], opn, tupledArg[1]), item(opn, fc.OutLinks));
                default: {
                    const tupledArg_1 = x;
                    return toFail(printf("Unexpected link match: %A"))([tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]]);
                }
            }
            break;
        }
    };
    const driverOf = fill(new Int32Array(f.NumStepArrays), 0, f.NumStepArrays, -1);
    const driverPort = new Int32Array(f.NumStepArrays);
    iteri((iDriver, fDriver) => {
        if (!isCustom(fDriver.FType)) {
            iterateIndexed_1((iOut, _arg) => {
                const array_1 = getLinks(iDriver, iOut, undefined);
                array_1.forEach((tupledArg_2) => {
                    const ipn_3 = tupledArg_2[1];
                    const fDriven = item(fcToInt(tupledArg_2[0]), store.Items);
                    const inputKey = item(ipn_3, fDriven.InputLinks).Index | 0;
                    const matchValue_3 = item(inputKey, driverOf) | 0;
                    if (matchValue_3 === -1) {
                    }
                    else {
                        const arg_3 = item(matchValue_3, store.Items).FullName;
                        const arg_4 = item(inputKey, driverPort) | 0;
                        toFail(printf("Multiple linkage: (previous driver was %A,%A)"))(arg_3)(arg_4);
                    }
                    setItem(driverOf, inputKey, iDriver | 0);
                    setItem(driverPort, inputKey, iOut | 0);
                    if (isIOLabel(fDriven.FType)) {
                        const labelKey = [fDriven.SimComponent.Label, fDriven.AccessPath];
                        if (!containsKey(labelKey, f.FIOActive)) {
                            f.FIOActive = add(labelKey, fDriven, f.FIOActive);
                            fDriven.Active = true;
                        }
                    }
                    if (isIOLabel(fDriver.FType)) {
                        f.FIOLinks = cons([[fDriven, ipn_3], fDriver], f.FIOLinks);
                    }
                    else {
                        fDriven.InputLinks[ipn_3] = item(iOut, fDriver.Outputs);
                        const matchValue_4 = getHybridComponentAsyncOuts(fDriven.FType, ipn_3);
                        let matchResult_1;
                        if (matchValue_4 != null) {
                            if (!isEmpty(matchValue_4)) {
                                matchResult_1 = 0;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 0;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                fDriver.DrivenComponents = cons(fDriven, fDriver.DrivenComponents);
                                break;
                            }
                        }
                        fDriven.InputDrivers[ipn_3] = [fDriver.Index, iOut];
                    }
                });
            }, fDriver.Outputs);
        }
    }, store);
    reLinkIOLabels(f);
    iteri((_arg_2, fc_1) => {
        fc_1.OutLinks = (new Array(0));
        fc_1.CustomInLinks = (new Array(0));
    }, store);
    instrumentTime("linkFastComponents", start);
    return f;
}

export function determineBigIntState(comps, f) {
    comps.forEach((fc) => {
        if (!isCustom(fc.FType)) {
            const patternInput = findBigIntState(fc);
            fc.UseBigInt = patternInput[0];
            fc.BigIntState = patternInput[1];
        }
    });
    return f;
}

